export enum Seniority {
  Junior = "Junior",
  Pleno = "Pleno",
  Senior = "Senior",
  Gestor = "Gestor",
}
